import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  num: '1',
  title: 'Bono #1: 50 Calentamientos Express',
  desc: 'Entra al gimnasio con el inicio de clase resuelto. 50 ideas rápidas para activar energía y foco en segundos.',
  price: 'Valor: 47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/5B5M7sN21ET2e7233tgGgV/Diseno-sin-titulo-_80_.webp'
}, {
  num: '2',
  title: 'Bono #2: Banco de Juegos Pedagógicos de Cierre',
  desc: 'Termina cada clase arriba. Juegos que refuerzan habilidades sin que los alumnos sientan que están "trabajando".',
  price: 'Valor: 37 USD',
  image: 'https://cdn.magicpatterns.com/uploads/vYVjfWqrsVpXzqoAX4uybG/Diseno-sin-titulo-_81_.webp'
}, {
  num: '3',
  title: 'Bono #3: Clases Especiales para Fechas Clave',
  desc: 'Clases temáticas listas para el Día del Niño, Navidad o Halloween. Sorprende a tus alumnos sin trabajar doble.',
  price: 'Valor: 47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/77JPjvAanwVT4wEzmSM2rc/Diseno-sin-titulo-_82_.webp'
}, {
  num: '4',
  title: 'Bono #4: Kit de Consignas Técnicas y Frases',
  desc: 'Más de 200 frases cortas para corregir errores rápido y sonar como un entrenador de élite frente al grupo.',
  price: 'Valor: 27 USD',
  image: 'https://cdn.magicpatterns.com/uploads/hem6Yc82mRQJwb1GY1VcbS/Diseno-sin-titulo-_83_.webp'
}, {
  num: '5',
  title: 'Bono #5: Plantillas de Organización Semanal',
  desc: 'Baja el ruido mental. Organiza grupos, materiales y objetivos en minutos con plantillas listas para imprimir.',
  price: 'Valor: 27 USD',
  image: 'https://cdn.magicpatterns.com/uploads/ou8Ga1ErK6JLDQRZT9xcU3/Diseno-sin-titulo-_84_.webp'
}];
export function Bonuses() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <span className="text-success font-bold tracking-widest text-sm uppercase mb-3 flex items-center justify-center gap-2" data-id="element-4">
            <span className="w-4 h-4 rounded-full bg-success/20 flex items-center justify-center" data-id="element-5">
              <span className="w-2 h-2 rounded-full bg-success" data-id="element-6"></span>
            </span>
            Bonos gratis incluidos
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy mb-4" data-id="element-7">
            Además de la biblioteca, te llevas estos regalos de aplicación
            inmediata
          </h2>
        </div>

        <div className="space-y-4" data-id="element-8">
          {bonuses.map((bono, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-cream-dark/20 rounded-2xl p-6 border border-gray-100 flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-9">
              <div className="w-40 sm:w-36 shrink-0 mx-auto sm:mx-0" data-id="element-10">
                <img src={bono.image} alt={bono.title} className="w-full h-auto object-contain drop-shadow-lg" data-id="element-11" />
              </div>
              <div className="flex-1" data-id="element-12">
                <h3 className="font-bold text-navy text-lg mb-1" data-id="element-13">
                  {bono.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-14">
                  {bono.desc}
                </p>
              </div>
              <div className="flex flex-row sm:flex-col items-center sm:items-end gap-3 sm:gap-1 mt-4 sm:mt-0 w-full sm:w-auto justify-between sm:justify-start border-t sm:border-t-0 border-gray-200 pt-4 sm:pt-0" data-id="element-15">
                <span className="text-gray-400 line-through text-xs font-medium" data-id="element-16">
                  {bono.price}
                </span>
                <span className="bg-success text-white font-bold text-xs px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-17">
                  Gratis
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 bg-navy text-white rounded-2xl p-8 text-center shadow-xl" data-id="element-18">
          <p className="text-lg sm:text-xl font-medium" data-id="element-19">
            Estos bonos tienen un valor total de{' '}
            <span className="font-heading font-black text-2xl text-primary mx-2" data-id="element-20">
              185 USD
            </span>
            <br className="hidden sm:block" data-id="element-21" />
            <span className="text-gray-300 text-base mt-2 inline-block" data-id="element-22">
              …y hoy se incluyen 100% gratis con tu ProfePack.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}